'use es6';

import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PromptablePropInterface from 'UIComponents/decorators/PromptablePropInterface';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { userDeclined } from '../../actions/PermissionsActions';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.optIn';
const OptInFlowContainerModal = props => {
  const {
    onClick,
    onConfirm,
    onReject,
    langKey
  } = props;
  const lang = (key, options = {}) => /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: `${LANG_ROUTE}.${langKey}.${key}`,
    options: options
  });
  const handleOptInClick = e => {
    e.preventDefault();
    if (typeof onClick === 'function') {
      onClick();
    }
    onConfirm();
  };
  const cancel = () => onReject(userDeclined());
  return /*#__PURE__*/_jsxs(Modal, {
    width: 600,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: cancel
      }), /*#__PURE__*/_jsx(H2, {
        children: lang('title')
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx("div", {
        style: {
          height: '400px',
          overflowY: 'scroll'
        },
        children: lang('body')
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleOptInClick,
        marginInline: "100",
        children: lang('confirmButton')
      }), /*#__PURE__*/_jsx(Button, {
        onClick: cancel,
        marginInline: "100",
        children: lang('cancelButton')
      })]
    })]
  });
};
OptInFlowContainerModal.propTypes = Object.assign({}, PromptablePropInterface, {
  langKey: PropTypes.string.isRequired
});
export default OptInFlowContainerModal;